module.exports = __webpack_public_path__ + "static/media/html.127221aa.png";